import type { IntlShape } from 'react-intl';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import StoreBadgeBase from '../StoreBadgeBase';

type GooglePlayProps = {
  height: number;
  intl: IntlShape;
  noReferrer?: boolean;
  languageRegionCode: LanguageRegionCode;
  className?: string;
};

export const GOOGLE_PLAY_URL_MAP: { [key in LanguageRegionCode]: string } = {
  ['da-DK']: 'https://alltrails.io/cA4y5EbQKqb',
  ['nl-NL']: 'https://alltrails.io/UPN437fRKqb',
  ['en-US']: 'https://alltrails.io/pW7o6i6Lmgb',
  ['en-GB']: 'https://alltrails.io/xJp9gViQKqb',
  ['fr-FR']: 'https://alltrails.io/iZe9jjaMmgb',
  ['de-DE']: 'https://alltrails.io/oEnYF1cMmgb',
  ['it-IT']: 'https://alltrails.io/hkRS2knRKqb',
  ['nb-NO']: 'https://alltrails.io/NpC9jwtRKqb',
  ['pl-PL']: 'https://alltrails.io/VzHxqGDRKqb',
  ['pt-PT']: 'https://alltrails.io/TVK8FZIRKqb',
  ['pt-BR']: 'https://alltrails.io/HANKR0KRKqb',
  ['es-ES']: 'https://alltrails.io/HIX8CIfMmgb',
  ['es-MX']: 'https://alltrails.io/McZM1cNRKqb',
  ['sv-SE']: 'https://alltrails.io/388JxQSRKqb'
};

const GooglePlay = ({ height, languageRegionCode, className = '', noReferrer = true, intl }: GooglePlayProps) => {
  // eslint-disable-next-line import/no-dynamic-require
  const src = require(`./google-play-badge-${languageRegionCode}.svg`).default;

  return (
    <StoreBadgeBase
      storeUrl={GOOGLE_PLAY_URL_MAP[languageRegionCode]}
      altText={intl.formatMessage({ defaultMessage: 'Download the AllTrails application on Google Play' })}
      src={src}
      height={height}
      dataTestId="google-app"
      className={className}
      noReferrer={noReferrer}
    />
  );
};
export default GooglePlay;
